import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import Textarea from 'react-textarea-autosize'
import 'styles/d3/textarea.scss'

// This is an autosizing textarea component

const D3Textarea = React.forwardRef((props, ref) => {
  if (!ref) {
    ref = useRef(null)
  }
  const _props = { ...props }
  delete _props.hasError
  const { className, disabled, hasError, onChange, placeholder } = _props

  const resize = () => {
    const el = ref.current
    el.style.minHeight = el.style.height
    el.style.minHeight = `${el.offsetHeight + 5}px`
  }
  const onTextChange = e => {
    if (onChange) onChange(e.target.value)
  }

  useEffect(() => {
    resize()
  }, [])

  let textAreaClassName = `d3-textarea ${className || ''}`
  textAreaClassName += hasError ? ' has-error' : ''
  return (
    <Textarea
      {..._props}
      disabled={disabled}
      className={textAreaClassName}
      spellCheck
      rows='1'
      inputRef={ref}
      onChange={onTextChange}
      onHeightChange={resize}
      placeholder={placeholder}
    />
  )
})

Textarea.propTypes = {
  disabled: PropTypes.bool,
  className: PropTypes.string,
  hasError: PropTypes.bool,
  onChange: PropTypes.func
}

export default D3Textarea
